import { Flex, FlexProps, createStylesContext, useMultiStyleConfig } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

const [StylesProvider, useStyles] = createStylesContext('Navigator');

export { StylesProvider, useStyles };

export default function Navigator({ children, ...props }: PropsWithChildren & FlexProps) {
  const styles = useMultiStyleConfig('Navigator');
  return (
    <Flex sx={styles.navigator} {...props}>
      <StylesProvider value={styles}>
        {children}
      </StylesProvider>
    </Flex>
  )
}
